import { motion } from "framer-motion";

export const ScrollReveal = ({
  children,
  delay = 0,
  y = 30,
  className = "",
  once = true,
  ...rest
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-80px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
      {...rest}
    >
      {children}
    </motion.div>
  );
};

export default ScrollReveal;
